<template>
  <v-container 
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        v-if="!_.isEmpty(projectInvestors)"
        md12
      >
        <h2>{{ $t('investors.myInvestors') }}</h2>
        <v-card>
          <v-data-table
            class="text-no-wrap" 
            :headers="headers"
            :items="projectInvestors"
            :hide-default-footer="true"
            :mobile-breakpoint="900"
            :items-per-page="200"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                v-text="header.text"
              />
            </template>
            <template v-slot:item.acronym="{ item }">
              <v-avatar
                :tile="false"
                :size="40"
                color="#f6f8f9"
              >
                <b class="text-primary">{{ item.investor.acronym }}</b>
              </v-avatar>  
            </template>
            <template v-slot:item.investor="{ item }">
              <b>{{ item.investor.name }}</b><br>
              <small>
                <b 
                  :class="colorStatus(item.status)"
                >
                  {{ $t('globals.'+item.status) }} 
                </b></small>
            </template>
            <template v-slot:item.project="{ item }">
              <b class="ticker">{{ item.project.ticker }}</b>
              <br><small class="name">{{ item.project.name }}</small>
            </template>
            <template v-slot:item.updated_at="{ item }">
              {{ item.updated_at | moment("L") }}
            </template>
            <template v-slot:item.aum="{ item }">
              <b
                v-if="item.investor.account_balance !== 0"
              >{{ item.investor.base_currency | renderSymbol }}
                {{ item.investor.account_balance }}</b>
              <b v-else>-</b>
            </template>
            <template v-slot:item.transfered_security_deposit="{ item }">    
              {{ item.investor.base_currency | renderSymbol }}
              {{ item.transfered_security_deposit }}
            </template>
           
            <template v-slot:item.actions="{ item }">
              <v-menu
                v-if="item.status == 'connected'"
                offset-y
                left
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    outlined 
                    small
                    text
                    v-on="on"
                  >
                    {{ $t('investors.detailsButton') }}
                  </v-btn>
                </template>
                <v-sheet
                  
                  dense
                >
                  <v-list-item
                    v-if="!item.copytrading"
                    @click="viewKeySecret(item)"
                  >
                    <v-list-item-title>{{ $t('accounts.key') }} </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="disconnectInvestor(item)"
                  >
                    <v-list-item-title>{{ $t('investors.cancelSub') }}</v-list-item-title>
                  </v-list-item>
                </v-sheet>
              </v-menu>
              <v-btn
                v-if="item.status == 'pending'"
                style="margin-right:10px;"
                class="primary"
                small
                @click="acceptRequest(item)"
              >
                {{ $t('investors.acceptButton') }}
              </v-btn>
              <v-btn
                v-if="item.status == 'pending'"
                outlined
                text
                small
                @click="declineRequest(item)"
              >
                {{ $t('investors.declineButton') }}
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex
        v-else
        md5
        xs12
        new-record
      >
        <v-row>
          <v-col cols="12">
            <v-row
              justify="center"
              align="center"
            >
              <v-col>
                <v-card
                  style="padding:50px"
                >
                  <component :is="newIcon" />
                  <h3>{{ $t('investors.myInvestors') }}</h3>
                  <p>{{ $t('investors.notFoundDesc') }}</p>
                </v-card> 
              </v-col>
            </v-row>  
          </v-col>
        </v-row>    
      </v-flex>
    </v-layout>
    <accept-dialog
      v-if="acceptDialog"
      :show-dialog="acceptDialog"
      :current-connection="selectedItem"
    />
    <decline-dialog
      v-if="declineDialog"
      :show-dialog="declineDialog"
      :current-connection="selectedItem"
    />
    <disconnect-dialog
      v-if="disconnectDialog"
      :show-dialog="disconnectDialog"
      :connection-id="parseInt(selectedItem.id)"
      @closeDisconnectDialog="closeDisconnectDialog"
    />
    <view-key-secret-dialog
      v-if="keySecretDialog"
      :show-dialog="keySecretDialog"
      :connection-id="parseInt(selectedItem.id)"
    />
  </v-container>
</template>

<script>

const PROJECT_INVESTORS_QUERY = require('@/graphql/queries/ProjectInvestorsList.gql');
import IconPortfolio from '@/components/icons/IconPortfolio.vue'
import AcceptDialog from '@/views/Investors/partial/AcceptDialog.vue'
import DeclineDialog from '@/views/Investors/partial/DeclineDialog.vue'
import DisconnectDialog from '@/views/Investors/partial/DisconnectDialog.vue'
import ViewKeySecretDialog from '@/views/Investors/partial/ViewKeySecretDialog.vue'
import { mapMutations } from 'vuex'

export default {
  name: 'ProjectInvestors',
  components: {
    AcceptDialog,
    DeclineDialog,
    DisconnectDialog,
    ViewKeySecretDialog
  },
  data() {
    return {
      acceptDialog: false,
      declineDialog: false,
      disconnectDialog: false,
      keySecretDialog: false,
      newIcon: IconPortfolio,
      loading: false,
      projectInvestors: [],
      pendingRequests: 0,
      selectedItem: {
        id: null
      },
      headers: [
        {
          sortable: false,
          text: '',
          value: 'acronym'
        },
        {
          sortable: false,
          text: this.$t('investors.investor'),
          value: 'investor'
        },
        {
          sortable: false,
          text: this.$t('investors.project'),
          value: 'project'
        },
        {
          sortable: false,
          text: this.$t('investors.amount'),
          value: 'aum'
        },
        {
          sortable: false,
          text: this.$t('investors.securityDeposit'),
          value: 'transfered_security_deposit'
        },
        {
          sortable: false,
          text: this.$t('investors.requestedAt'),
          value: 'updated_at',
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    }
  },
  beforeDestroy() {
    this.$apollo.queries.projectInvestors.stopPolling()
  },
  methods: {
    ...mapMutations('app', ['setPendingRequests']),
    acceptRequest(item) {
      this.selectedItem = item
      this.acceptDialog = true
    },
    declineRequest(item) {
      this.selectedItem = item
      this.declineDialog = true
    },
    disconnectInvestor(item) {
      this.selectedItem = item
      this.disconnectDialog = true
    },
    viewKeySecret(item) {
      this.selectedItem = item
      this.keySecretDialog = true
    },
    closeDisconnectDialog(val) {
      this.disconnectDialog = false
      if (val == 'disconnect') {
        this.$apollo.queries.projectInvestors.refetch()
      }
    }
  },
  apollo: {
    projectInvestors: {
      query: PROJECT_INVESTORS_QUERY,
      pollInterval: 10000,
      result ({ data, loading, networkStatus }) {
        if (loading == false) {
          this.pendingRequests = 0
          let pendings = _.filter(data.projectInvestors, o => {return o.status == 'pending'});
          this.pendingRequests = pendings.length
          this.setPendingRequests(this.pendingRequests)
        }
      },
    }
  },
}
</script>
<style lang="scss" scoped>
  .v-avatar {
    margin: 10px 0;
  }
  .ticker {
    font-weight: 700;
    color: #9c27b0;
  }
</style>
